import { render, staticRenderFns } from "./object-name.vue?vue&type=template&id=276d93cc&"
import script from "./object-name.vue?vue&type=script&lang=js&"
export * from "./object-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports